<template lang="pug">
  Icon.icon(name="notification-play" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Создана задача
    Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
    |  в проекте
    Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
</template>

<script>
export default {
  name: 'NotificationTaskPublish',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
